module.exports = __webpack_public_path__ + "static/media/desktop.5129ab1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Glasses/desktop.mp4
// module id = cPIP
// module chunks = 1